var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._m(0),_c('div',{ref:"responsiblePersonOrderStatisticsChart",staticStyle:{"height":"300px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-flex custom-items-center"},[_c('div',{staticClass:"icon"}),_c('span',[_vm._v("负责人订单数量排名")])])
}]

export { render, staticRenderFns }